import React from 'react';
import withSidebar from 'components/HOC/withSidebar';
import OrganizationTemplate from '../components/templates/Organization/Organization.template';

const Organization = () => <OrganizationTemplate />;

export default withSidebar(Organization);
